/**
 * 결제 서비스
 */

import apiClient from './api';
import { Payment, PaymentFilter, PaymentListResponse, PaymentStatistics } from '../types/payment';

export const paymentService = {
  /**
   * 결제 목록 조회
   */
  async getPayments(filter: PaymentFilter = {}): Promise<PaymentListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.payment_method) params.append('payment_method', filter.payment_method);
    if (filter.date_from) params.append('date_from', filter.date_from);
    if (filter.date_to) params.append('date_to', filter.date_to);
    if (filter.payment_number) params.append('payment_number', filter.payment_number);
    if (filter.booking_number) params.append('booking_number', filter.booking_number);
    if (filter.pg_provider_id) params.append('pg_provider_id', filter.pg_provider_id.toString());
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PaymentListResponse }>(`/admin/payments?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      payments: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 결제 상세 조회
   */
  async getPayment(id: number): Promise<Payment> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { payment: Payment } }>(`/admin/payments/${id}`);
    // return response.data.data.payment;

    throw new Error('Not implemented');
  },

  /**
   * 결제 통계 조회
   */
  async getPaymentStatistics(filter?: { date_from?: string; date_to?: string }): Promise<PaymentStatistics> {
    const params = new URLSearchParams();
    if (filter?.date_from) params.append('date_from', filter.date_from);
    if (filter?.date_to) params.append('date_to', filter.date_to);

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PaymentStatistics }>(`/admin/payments/statistics?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      total_revenue: 0,
      today_revenue: 0,
      week_revenue: 0,
      month_revenue: 0,
      total_count: 0,
      completed_count: 0,
      pending_count: 0,
      refunded_count: 0,
      by_method: {
        card: 0,
        qrcode: 0,
      },
    };
  },

  /**
   * 환불 처리
   */
  async refundPayment(id: number, reason: string): Promise<Payment> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { payment: Payment } }>(`/admin/payments/${id}/refund`, { reason });
    // return response.data.data.payment;

    throw new Error('Not implemented');
  },
};

